import { inject, Injectable } from '@angular/core';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutSingleComponent, ListSortOption, SkeletonLoaderLayout } from 'gung-list';
import { Observable, of } from 'rxjs';
import { CustomerContactCardListComponent } from '../../components/customer-contact-card-list/customer-contact-card-list.component';
import { CustomerContact } from '../../models/customerContact';
import { CustomerContactService } from '../customer-contacts/customer-contact.service';
import { SelectedCustomerService } from '../selected-customer/selected-customer.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerContactListConfigService implements ConfigService<CustomerContact> {
  protected customerContactService = inject(CustomerContactService);
  protected selectedCustomerService = inject(SelectedCustomerService);
  
  skeletonLoaderLayout: SkeletonLoaderLayout = 'list';
  /*
   This variable and setter is called in the customer-contact-list-component to set
   the customerId to the id in the route params. It did not work to get the routeparams
   from this service.
   */
  customerId: string;
  setCustomerId(customerId: string) {
    this.customerId = customerId;
  }

  getItems(): Observable<CustomerContact[]> {
    if (this.customerId == null) {
      return of([]);
    }

    return this.customerContactService.getCustomerContacts(this.customerId);
  }

  getFilters(): ConfigBaseFilter<CustomerContact>[] {
    return [];
  }

  getSortOptions(): ListSortOption<CustomerContact>[] {
    return [];
  }

  getBatchSizes(): number[] {
    return [24];
  }

  getLayouts(): ListLayout<CustomerContact>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CustomerContactCardListComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'CustomerContacts grid'
      }
    ];
  }

  getSearchTerms(item: any): string[] {
    return [item.id];
  }

  getItemId(item: any): string {
    return item.id;
  }

  getNothingFoundTranslateTag() {
    return 'NOTHING_FOUND';
  }
}
